export default __webpack_public_path__ + "static/media/en-flag.2d19fed4.svg";